class Sitemap {
  constructor() {
    this.sitemapPage = document.querySelector(".SitemapPage")
    this.initSitemapLinks()
  }

  initSitemapLinks() {
    if (this.sitemapPage) {
      this.sitemapPage.addEventListener("click", e => {
        const link = e.target.closest("[js-load-sitemap]")

        if (link) {
          e.preventDefault()
          const pageId = link.dataset.pageId

          // if data is already loaded on page or in cache, no need for request
          if (this.getChildrenContainer(pageId).innerHTML || this.loadSitemap(pageId)) {
            return
          }

          this.getChildrenContainer(pageId).innerHTML = `<span class="text-primary">Please wait ...</span>`

          fetch(`${window.location.pathname}/page/${pageId}`, {
            headers: {
              "x-requested-with": "XMLHttpRequest",
            },
          })
            .then(response => response.text())
            .then(data => {
              if (typeof Storage !== "undefined") {
                sessionStorage.setItem(this.getCacheId(pageId), data)
              }
              this.loadSitemap(pageId, data)
            })
        }
      })
    }
  }

  /**
   * Given a page ID and some sitemap data, load it into the DOM. Will load from
   * the local cache if available.
   */
  loadSitemap(pageId, data = null) {
    let sitemapData = data
    // Attempt to load from cache
    if (data === null && typeof Storage !== "undefined" && sessionStorage.getItem(this.getCacheId(pageId)) !== null) {
      sitemapData = sessionStorage.getItem(this.getCacheId(pageId))
    }

    this.getChildrenContainer(pageId).innerHTML = sitemapData

    // return !!sitemapData
    return false
  }

  getChildrenContainer(pageId) {
    return document.querySelector(`#children-${pageId}`)
  }

  getCacheId(pageId) {
    return `sitemap-cache-${pageId}`
  }
}

export default Sitemap
